export const CODE_BLOCK_STYLE = {
  maxHeight: '40vh',
  maxWidth: '100%',
  overflow: 'auto',
  whiteSpace: 'pre-wrap' as const,
  wordBreak: 'break-word' as const,
};
